export function AboutPage() {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-12 py-20">
      <div className="text-xs tracking-[0.25em] uppercase text-terracotta mb-4">The Mission</div>
      <h1
        className="text-6xl text-forest mb-12 leading-tight font-display"
        style={{ fontVariationSettings: '"opsz" 144' }}
      >
        A neighborhood-scale answer to a quiet problem.
      </h1>

      <div className="prose prose-lg text-forest/85 max-w-none space-y-6"
           style={{ fontSize: '1.125rem', lineHeight: '1.75' }}>
        <p>
          Drive any street in Corpus Christi and you'll see them — homes where the
          grass has grown waist-high, where a code enforcement notice is stuck to
          the door, where someone inside is too old, too sick, or too overwhelmed
          to deal with it. These aren't bad homeowners. They're our neighbors at
          their hardest moments.
        </p>
        <p>
          MowKind is a coordinated response. Local lawn care professionals
          volunteer a small share of their monthly capacity. Each application is
          reviewed personally and confidentially by our small team. We pair the
          two. The work gets done, dignity intact.
        </p>

        <h2 className="text-3xl text-forest mt-12 mb-4 font-display">The 501(c)(3) path</h2>
        <p>
          MowKind is launching under a fiscal sponsorship arrangement with
          an established 501(c)(3), allowing tax-deductible donations to flow
          through to our work from day one. We are concurrently pursuing our own
          federal tax-exempt status via IRS Form 1023-EZ.
        </p>

        <h2 className="text-3xl text-forest mt-12 mb-4 font-display">What providers actually get</h2>
        <p>
          Lawn care companies who become Mowkins receive: priority routing on
          quote requests we receive from the community; recognition on yard signs
          placed at every recipient property; inclusion in our marketing and press
          coverage; and the ability to deduct legitimate out-of-pocket expenses
          (fuel, supplies, mileage at the IRS charitable rate) incurred while
          volunteering.
        </p>
        <p className="text-sm text-forest/60 italic border-l-2 border-terracotta pl-4">
          Note: Under IRC § 170, the value of donated services themselves is not
          tax-deductible. Out-of-pocket expenses and mileage incurred in service
          of a qualified 501(c)(3) are. Providers should consult their tax
          professional.
        </p>

        <h2 className="text-3xl text-forest mt-12 mb-4 font-display">Founding partner</h2>
        <p>
          Bay Area Landscape — Coastal Bend supplier of bulk materials, sod, and
          hardscape — is our founding Mowkin partner, providing materials and
          logistical support. Their commitment to the community makes this program
          possible at launch.
        </p>
        <p>
          Contact: 5901 La Costa, Corpus Christi · (361) 826-0680 ·{' '}
          <a
            href="https://www.mybayarealandscapes.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-terracotta hover:underline"
          >
            mybayarealandscapes.com
          </a>
        </p>
      </div>
    </div>
  );
}
